import "./index.css";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { MIN_SIZE } from "./features/ui";

// Set CSS variable from JS constant
document.documentElement.style.setProperty("--min-size", `${MIN_SIZE}px`);

// Sentry (only in production)
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://1e5b567b64354af856d223a74e97db1b@o4507453182967808.ingest.us.sentry.io/4510752918208512",
    sendDefaultPii: true,
    ignoreErrors: [/Failed to fetch \(www\.google-analytics\.com\)/],
    denyUrls: [/google-analytics\.com/i, /googletagmanager\.com/i],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({ levels: ["error"] }),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/motion\.gliadirector\.com/,
      /^https:\/\/api\.gliadirector\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
